import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { ecosystemGovernance } from "@/mocks/ecosystemData";
import { steeringBoard } from "@/mocks/homeData";
import { Link } from "react-router-dom";

export default function EcosystemGovernance() {
  const leadership = steeringBoard.filter((m) => m.isLeadership);
  const members = steeringBoard.filter((m) => !m.isLeadership);

  return (
    <section className="bg-white py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-6">
                <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                  / Governance
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary leading-tight">
                {ecosystemGovernance.title}
              </h2>
              <p className="mt-3 md:mt-4 text-base md:text-lg text-tie-text-secondary">
                {ecosystemGovernance.subtitle}
              </p>
            </div>
          </ScrollReveal>

          {/* Governance Stats */}
          <ScrollReveal delay={100}>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-10 md:mb-14">
              {ecosystemGovernance.boardHighlights.map((item, i) => (
                <div
                  key={item.label}
                  className="p-5 md:p-6 rounded-xl bg-tie-grey-light border border-tie-grey-dark text-center"
                >
                  <p className="font-serif text-2xl md:text-3xl font-bold text-tie-navy">
                    {item.value}
                  </p>
                  <p className="mt-1 text-sm text-tie-text-secondary">
                    {item.label}
                  </p>
                </div>
              ))}
            </div>
          </ScrollReveal>

          {/* Description */}
          <ScrollReveal delay={150}>
            <p className="text-center text-sm md:text-base text-tie-text-secondary leading-relaxed max-w-3xl mx-auto mb-10 md:mb-14">
              {ecosystemGovernance.description}
            </p>
          </ScrollReveal>

          {/* Leadership */}
          <div className="mb-8 md:mb-10">
            <ScrollReveal>
              <h3 className="text-center text-sm font-semibold text-tie-text-muted uppercase tracking-wider mb-6 md:mb-8">
                Steering Board Leadership
              </h3>
            </ScrollReveal>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-3xl mx-auto">
              {leadership.map((member, index) => (
                <ScrollReveal key={member.name} delay={index * 120}>
                  <div className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-tie-grey-light border border-tie-grey-dark hover:border-tie-teal/30 transition-all duration-300">
                    <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl overflow-hidden shrink-0 bg-white">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div>
                      <p className="text-sm md:text-base font-semibold text-tie-text-primary">
                        {member.name}
                      </p>
                      <p className="text-xs md:text-sm text-tie-teal font-medium">
                        {member.title}
                      </p>
                      <p className="text-xs text-tie-text-muted mt-0.5">
                        {member.company}
                      </p>
                    </div>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>

          {/* Members Grid */}
          <div>
            <ScrollReveal>
              <h3 className="text-center text-sm font-semibold text-tie-text-muted uppercase tracking-wider mb-6 md:mb-8">
                Steering Board Members
              </h3>
            </ScrollReveal>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {members.map((member, index) => (
                <ScrollReveal key={member.name} delay={index * 80}>
                  <div className="p-4 md:p-5 rounded-xl bg-tie-grey-light border border-tie-grey-dark hover:border-tie-teal/30 transition-all duration-300">
                    <div className="w-full aspect-[4/3] rounded-lg overflow-hidden mb-3 md:mb-4 bg-white">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <p className="text-sm font-semibold text-tie-text-primary">
                      {member.name}
                    </p>
                    <p className="text-xs text-tie-teal font-medium mt-0.5">
                      {member.title}
                    </p>
                    <p className="text-xs text-tie-text-muted mt-0.5">
                      {member.company}
                    </p>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>

          {/* CTA */}
          <ScrollReveal delay={200}>
            <div className="mt-10 md:mt-12 text-center">
              <Link
                to="/about"
                className="inline-flex items-center justify-center px-7 py-3.5 rounded-full bg-tie-navy text-white font-medium text-sm hover:bg-tie-navy-light transition-all duration-300 whitespace-nowrap"
              >
                Learn More About TIE Governance
                <i className="ri-arrow-right-line ml-2" />
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}